import { DefaultProvidersInvitations } from "types/Permissions";

export function shouldAutoSelectAllProviders(
  defaultProvidersInvitation: string | undefined,
  selectedProvidersCount: number,
  minimumInvitesPossible: number,
  providerOptionsCount: number,
): boolean {
  if (providerOptionsCount === 0) {
    return false;
  }

  if (
    selectedProvidersCount === 0 &&
    defaultProvidersInvitation === DefaultProvidersInvitations.PROVIDERS_INVITATION_ALL_OPTIONAL
  ) {
    return true;
  }

  if (areAllProvidersRequired(defaultProvidersInvitation, minimumInvitesPossible, providerOptionsCount)) {
    return true;
  }

  return false;
}

export function areAllProvidersRequired(
  defaultProvidersInvitation: string | undefined,
  minimumInvitesPossible: number,
  providerOptionsCount: number,
): boolean {
  return (
    (minimumInvitesPossible > 0 && minimumInvitesPossible === providerOptionsCount) ||
    defaultProvidersInvitation === DefaultProvidersInvitations.PROVIDERS_INVITATION_ALL_MANDATORY
  );
}
